import styled from "styled-components/macro";

/**
 * Wrapper component that adds a scrollable container to its children.
 * @param {React.ReactNode} props.children - The children to be rendered inside the Scrollable component.
 * @param {string} [props.maxHeight="350px"] - The maximum height of the Scrollable component.
 * @returns {React.ReactNode} The Scrollable component with the provided children and maximum height.
 */
export default function Scrollable({ children, maxHeight = "350px" }) {
  return <ScrollableContainer style={{ maxHeight }}>{children}</ScrollableContainer>;
}

const ScrollableContainer = styled.div`
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: var(--scrollbar-track);
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--scrollbar-thumb);
    border-radius: 5px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: var(--scrollbar-thumb-hover);
  }
`;
